/** Default column definition shared by all AgGrid tables */
export const defaultColDef = {
  flex: 1,
  minWidth: 100,
  resizable: true,
  floatingFilter: true,
};

/** Default grid props shared by all AgGrid tables */
export const defaultGridProps = {
  rowModelType: 'serverSide',
  pagination: true,
  paginationPageSize: 100,
  cacheBlockSize: 100,
  maxBlocksInCache: 1,
  animateRows: true,
  columnHoverHighlight: true,
  debug: false,
};
